import { render, staticRenderFns } from "./WidgetCounter.vue?vue&type=template&id=550caa67"
import script from "./WidgetCounter.vue?vue&type=script&lang=js"
export * from "./WidgetCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports